const SORTING_TYPES = {
    number: ['Connected', 'Converted', 'Cost', 'Dupe', 'Incoming', 'Live', 'No Connect', 'Paid', 'Payout', 'Profit', 'Qualified', 'Revenue'],
    time: ['TCL', 'ACL'],
    date: ['Date'],
}

export { SORTING_TYPES }
